// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1axlJ","title":"InfoRow_title__2Bref"};